// Monitoraggio del frontend su Grafana Cloud (Faro): Web Vitals, errori JS,
// pagine e tempi delle chiamate API. Caricato da index.html prima dell'app,
// cosi' vede anche gli errori di avvio; senza VITE_FARO_URL non parte.
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import type { TransportItem } from '@grafana/faro-web-sdk';

// Percorsi con parametri riservati: escono i nomi di tutti i parametri, i valori
// solo di quelli elencati, gli altri diventano `_`. Gli URL degli altri
// percorsi escono interi.
const PARAMS_SENT_PER_PATH: Record<string, readonly string[]> = {
  '/reset-password': [],
};

// Origine, percorso e query di un URL assoluto; il frammento resta fuori.
const URL_WITH_QUERY = /(https?:\/\/[^\s/?#"']*)(\/[^\s?#"']*)\?([^\s#"']*)/g;

const redactQuery = (query: string, sent: readonly string[]) =>
  query
    .split('&')
    .map((pair) => {
      const [key = ''] = pair.split('=');
      return pair.includes('=') && !sent.includes(key) ? `${key}=_` : pair;
    })
    .join('&');

const redactUrls = (value: unknown): unknown => {
  if (typeof value === 'string') {
    return value.replace(URL_WITH_QUERY, (match, origin: string, path: string, query: string) => {
      const sent = PARAMS_SENT_PER_PATH[path];
      return sent ? `${origin}${path}?${redactQuery(query, sent)}` : match;
    });
  }
  if (Array.isArray(value)) return value.map(redactUrls);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, inner]) => [key, redactUrls(inner)])
    );
  }
  return value;
};

const url = import.meta.env.VITE_FARO_URL;

if (url) {
  initializeFaro({
    url,
    app: {
      name: 'movofleet-frontend',
      environment: import.meta.env.VITE_FARO_ENV,
      version: import.meta.env.VITE_APP_VERSION || undefined,
    },
    sessionTracking: { samplingRate: Number(import.meta.env.VITE_FARO_SAMPLE_RATE || 1) },
    instrumentations: getWebInstrumentations(),
    // Lo stesso oggetto, con gli stessi campi: cambiano solo gli URL in elenco.
    beforeSend: (item) => redactUrls(item) as TransportItem,
  });
}
